import { getClient } from 'lane-shared/apollo';
import { resendVerificationEmail } from 'lane-shared/graphql/user';

export default async function resendVerificationEmailHelper(
  email: string
): Promise<boolean> {
  try {
    await getClient().mutate({
      mutation: resendVerificationEmail,
      variables: {
        email,
      },
    });

    return true;
    // FIXME: Log error for datadog, missing stack trace
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (err) {
    return false;
  }
}
